import { render, staticRenderFns } from "./SystemParametersList.vue?vue&type=template&id=1bbf8aa5&"
import script from "./SystemParametersList.vue?vue&type=script&lang=js&"
export * from "./SystemParametersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports